import { createSlice } from "@reduxjs/toolkit";
import APPCONFIG from "constants/appConfig";
import axios from "axios";

// https://www.membug.com/note/72f48c5bbab40

// initial state
export const initialState = {
  data: {},
  dataSAP: {},
  saving: false
};

export const menuitemSlice = createSlice({
  name: "menuitem",
  initialState,
  reducers: {
    menuitem_update: (state, action) => {
      let key = Object.keys(action.payload)[0];
      console.log(
        "menuitem_update",
        action.payload[key],
        state.data,
        state.dataSAP
      );

      if (!state.data) {
        state.data = [];
      }

      if (!action.payload[key]) {
        let tmp = { ...state.data };
        delete tmp[key];
        state.data = Object.keys(tmp).length > 0 ? tmp : null;
      } else {
        let tmp = { ...state.data };
        tmp[key] = action.payload[key]
        state.data = tmp;
      }
      /* if (!action.payload[key]) {
        // remove
        console.log("should remove!")
        let tmp = state.data;
        console.log("tmp",tmp);
        if (delete tmp[key]) {
          console.log("deleted",tmp)
          return {
            ...state,
            data: { ...state.data, [key]: tmp }
          };
        }
      }

      return {
        ...state,
        data: { ...state.data, [key]: action.payload[key] }
      }; */
    },
    menuitem_setData: (state, action) => {
      console.log("menuitem_setData", action.payload);
      state.data = action.payload;
      state.dataSAP = action.payload;
    },
    setSaving: (state, action) => {
      state.saving = action.payload;
    }
  }
});

// export the actions
export const {
  menuitem_setData,
  menuitem_update,
  setSaving
} = menuitemSlice.actions;

export const menuitemSelector = state => state.menuitem;

export default menuitemSlice.reducer;

// save item
export function saveData(state) {
  return async (dispatch, getState) => {
    dispatch(setSaving(true));

    const axiosConfig = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      withCredentials: true
    };

    axios
      .post(
        APPCONFIG.host + "api/lunchorder/menuitem",
        {
          item: getState().menuitem.data
        },
        axiosConfig
      )
      .then(res => {
        console.log("item saved", res);
        console.log("item saved", JSON.parse(res.data).data);
        dispatch(menuitem_setData(JSON.parse(res.data).data));
        dispatch(setSaving(false));
      })
      .catch(error => {
        console.log("error", error);
        dispatch(setSaving(false));
      });
  };
}
